import React, { useState } from "react";
import {
  Link,
} from "react-router-dom";
import { MdMenu } from "react-icons/md";

import Menu from '../components/Menu'

const MainLayout = ({ children, title }) => {
  const [open, setOpen] = useState(false)
  
  return (
    <main className="md:flex bg-gray-100 dark:bg-gray-800 h-full min-h-screen">
      <div className="bg-blue-800 text-gray-100 flex justify-between md:hidden">
        <Link to="/" className="block p-4 text-gray-100 font-bold">Autolini</Link>
        <button
          className="mobile-menu-button p-4 focus:outline-none focus:bg-gray-700"
          onClick={setOpen.bind(this, !open)}
        >
          <MdMenu />
        </button>
      </div>

      <div style={{ zIndex: 9999 }} className={`sidebar flex flex-col shadow-lg bg-white text-gray-800 dark:text-white w-64 space-y-6 py-7 px-2 absolute inset-y-0 left-0 transform ${!open && '-translate-x-full'} md:relative md:translate-x-0 transition duration-200 ease-in-out`}>
        <Link to="/" className="text-white flex items-center pl-8 space-x-2 px-4">
          <span className="font-bold text-gray-800 dark:text-white text-xl">Autolini</span>
        </Link>
        <Menu />
        <div className="w-full text-center">
          <small className="font-light text-center">
            Version 1.0.0
          </small>          
        </div>
      </div>
      <div className="flex-1 p-10 bg-gray-100 h-full">
        {children}
        <div className="mt-15 text-right text-sm text-gray-400">
          <a className="hover:text-gray-800 dark:text-gray-300 dark:hover:text-white transition-colors duration-200" href="/cgv.pdf">
            Conditions Générales d'Utilisation et de Vente
          </a>
          &nbsp;|&nbsp;
          <a className="hover:text-gray-800 dark:text-gray-300 dark:hover:text-white transition-colors duration-200" href="/politique_de_Confidentialite.pdf">
            Politique de confidentialité
          </a>
        </div>
      </div>
    </main>
  );
}

export default MainLayout